// --- Components ---
import ButtonGoback from "../../../components/button/buttonGoback";
import dayjs from 'dayjs';
import { useNavigate } from "react-router-dom";
import { useResponsive } from "../../../hooks/mediaQuery";
import { UrlCollection } from "../../../common/url-collection";
import { Pencil } from "lucide-react";

// --- Models ---
import { StandardItem } from "../../../models/types/standard";
import { useTranslation } from "react-i18next";
interface FormProps {
  data: StandardItem | null;
}

export default function StandardView({ data }: FormProps) {
  const navigate = useNavigate();
  const { isXs } = useResponsive();
  const { t } = useTranslation()
  return (
    <>
      <div className="w-full h-full" >
        <div className="flex justify-between items-center mb-4 sticky top-0 z-10 bg-gray-100">
          <ButtonGoback />
          <button
            className="btn shadow-sm text-sm font-medium bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-200"
            onClick={() => navigate(UrlCollection.EditStandard.replace(":id", data?.id?.toString() || ""))}
          >
            <div
              className="flex items-center gap-1 italic text-blue-500 text-sm"
            >
              <Pencil size={12} />
              {t('standard.actions.edit')}
            </div>
          </button>
        </div>
        <div className="rounded-lg border border-gray-200 shadow-sm bg-white p-4 mb-2">
          <div className="flex items-end gap-2">
            <span className="font-semibold text-gray-600 ">{t('standard.view.info.name')}</span>
            <span className={`font-medium ${isXs ? 'text-[16px]' : 'text-[20px]'} text-green-600`}>{data?.name}</span>
          </div>
          <div className="flex gap-2">
            <span className="font-semibold text-gray-600">{t('standard.view.info.description')}</span>
            <span className="font-medium">{data?.description}</span>
          </div>
          <div className="flex gap-2">
            <span className="font-semibold text-gray-600">{t('standard.view.info.issuedDate')}</span>
            <span className="font-medium">{data?.issuedDate ? dayjs(data?.issuedDate).format('DD/MM/YYYY') : '-'}</span>
          </div>
          <div className="flex gap-2">
            <span className="font-semibold text-gray-600">{t('standard.view.info.effectiveDate')}</span>
            <span className="font-medium">{data?.effectiveDate ? dayjs(data?.effectiveDate).format('DD/MM/YYYY') : '-'}</span>
          </div>
          <div className="flex gap-2">
            <span className="font-semibold text-gray-600">{t('standard.view.info.endDate')}</span>
            <span className="font-medium">{data?.endDate ? dayjs(data?.endDate).format('DD/MM/YYYY') : '-'}</span>
          </div>
        </div>
        <div className="rounded-lg border border-gray-200 shadow-sm bg-white">
          <div className="p-2">
            <h2 className="text-lg font-semibold text-center">{t('standard.view.parameterListTitle')}</h2>
          </div>
          <div className="relative overflow-x-auto ">
            <table className="min-w-full text-sm text-left text-gray-700">
              <thead className="bg-gray-200 text-sm font-semibold uppercase text-gray-600">
                <tr>
                  <th className="px-4 py-3 text-left w-[50px]">{t('standard.table.stt')}</th>
                  <th className="px-4 py-3 text-left">{t('standard.table.code')}</th>
                  <th className="px-4 py-3 text-left min-w-[240px]">{t('standard.table.parameter')}</th>
                  <th className="px-4 py-3 text-left">{t('standard.table.unit')}</th>
                  <th className="px-4 py-3 text-left min-w-[120px]">{t('standard.table.standardA')}</th>
                  <th className="px-4 py-3 text-left min-w-[120px]">{t('standard.table.standardB')}</th>
                  <th className="px-4 py-3 text-left min-w-[120px]">{t('standard.table.standardC')}</th>
                </tr>
              </thead>
              <tbody>
                {data?.parameterStandardViews && data?.parameterStandardViews?.length > 0 ? (
                  data?.parameterStandardViews?.map((item, index) => (
                    <tr key={index} className={`${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} hover:bg-gray-100`}>
                      <td className="px-4 py-3 text-left">{index + 1}</td>
                      <td className="px-4 py-3 text-left">{item.parameter?.code}</td>
                      <td className="px-4 py-3 text-left">{item.parameter?.name}</td>
                      <td className="px-4 py-3 text-left">{item.parameter?.unitName}</td>
                      <td className="px-4 py-3 text-left">{item.standardA}</td>
                      <td className="px-4 py-3 text-left">{item.standardB}</td>
                      <td className="px-4 py-3 text-left">{item.standardC}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={7} className="px-4 py-4 text-center text-gray-500">
                      {t('standard.view.noData')}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}